import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 6a3 3 0 1 0 6 0a3 3 0 0 0 -6 0","key":"svg-0"}],["path",{"d":"M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3","key":"svg-1"}],["path",{"d":"M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3","key":"svg-2"}],["path",{"d":"M15 18a3 3 0 1 0 6 0a3 3 0 0 0 -6 0","key":"svg-3"}]]

const IconTransform = createReactComponent('outline', 'transform', 'Transform', __iconNode);

export default IconTransform;